(() => {
  'use strict';

  const TEXT = 'Consegna prevista: 24–48h lavorative · fino a 72h nei periodi di maggiore richiesta';

  const createRow = () => {
    const row = document.createElement('div');
    row.className = 'ra-cart-delivery-window';
    row.setAttribute('role', 'note');
    row.textContent = TEXT;
    return row;
  };

  const inject = () => {
    const selectors = [
      '#MinimogCartDrawer [data-cart-subtotal]',
      '#MinimogCart [data-cart-subtotal]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach((subtotal) => {
      const next = subtotal.nextElementSibling;
      if (next?.classList.contains('ra-cart-delivery-window')) return;

      const summary = subtotal.closest('.m-cart__summary, .m-cart-drawer__summary');
      if (summary?.querySelector('.ra-cart-delivery-window')) return;

      subtotal.insertAdjacentElement('afterend', createRow());
    });
  };

  const start = () => {
    inject();
    const observer = new MutationObserver(inject);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('cart:updated', inject);
  document.addEventListener('cart:refresh', inject);
  document.addEventListener('shopify:section:load', inject);
})();
